package com.essntl.features.client.ui.allclients

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.features.client.domain.model.ClientModel

data class AllClientsState(
    val getAllClients: PaginationState<ClientModel> = PaginationState(),
)
